import type { ProfessionalTileProps } from '@archipro-design/aria';
import type { SearchResultItem } from '@modules/search';
import type { ProfessionalTileViewModel } from '@modules/professional/type';
import type { User } from '~/server/types';
import { getProfessionalTileThumbnail } from '~/utils';
import { getTileEditableItems } from '~/modules/directory/util/tile-helpers';

export const mapESProfessionalTileViewModel = (
    professional: SearchResultItem,
    size: ProfessionalTileProps['size'] = 'medium',
    isMobile?: boolean,
    user?: User,
): ProfessionalTileViewModel => {
    const liveDateTimestamp = professional.LiveDate
        ? Number(professional.LiveDate) * 1000
        : 0;

    return {
        tile: {
            image: [getProfessionalTileThumbnail(professional, isMobile)],
            logo: {
                image: professional.CompanyLogos?.Thumb_lg ?? '',
                variables: {
                    avatarImageBackgroundColor:
                        professional.LogoBackgroundColor?.toString() ?? 'white',
                    avatarBackgroundColor: 'unset',
                },
            },
            category: professional.Categories?.[0] ?? '',
            title: professional.Professional ?? '',
            memberSince: liveDateTimestamp
                ? new Date(liveDateTimestamp).getFullYear()
                : null,
            size,
            services: professional.Services ?? [],
            hasAwards: professional.HasAwards ?? false,
            ...getTileEditableItems({
                professional: {
                    ID: professional.id,
                    Link: professional.Link || '',
                },
                itemType: 'professionals',
                itemLink: professional.Link || '',
                user,
            }),
        },
        link: professional.Link ?? '',
        professionalID: professional.id,
    };
};
